module.exports = __webpack_public_path__ + "static/app_screen_1-beca1a87d4caa1bdc935d654600190aa.png";